import * as React from 'react';
import {useState} from 'react';
import {Link} from "react-router-dom";
import {UserAgreement} from "../UserAgreement";
import {useAuth} from "../../contexts/AuthContext";
import {UsersService} from "../../api";

type Props = {};
export const Footer: React.FC<Props> = () => {

    const [isUserAgreementOpen, setIsUserAgreementOpen] = useState(false);

    const handleClosePopups = () => {
        setIsUserAgreementOpen(false);
    };


    const { user, setUser } = useAuth();

    if (user && !user.agreed_terms) {
        return (
        <UserAgreement
            isOpen={true}
            onClose={() => {}}
            onConfirm={async () => {
                await UsersService.agreeTerms();
                setUser({ ...user, agreed_terms: true, agreed_terms_at: new Date().toISOString() });
            }}
        />
    )}

    return (
        <footer className='footer'>
            <p className='footer__copyright'>&copy;&nbsp;2026</p>
            <Link to='#'
                  onClick={() => setIsUserAgreementOpen(true)}
                  className='footer__copyright'
            >Пользовательское соглашение</Link>

            <UserAgreement isOpen={isUserAgreementOpen}
                           onClose={handleClosePopups}
            />
        </footer>
    );
};
